import React from 'react';
import { HERO, IMAGES, PRICE } from '../constants/content';
import { CtaButton } from './CtaButton';
import { StarRating } from './StarRating';
export function HeroSection() {
  return <section className="w-full bg-bordo-deep text-cream" data-id="element-122" data-mp="23vbcl2g741oy">
      <div className="mx-auto max-w-6xl px-4 py-10 b720:px-6 b900:py-14" data-id="element-123" data-mp="23ww4ekb4l6j4">
        {/* Main headline — centered, above the product image */}
        <h1 className="mx-auto max-w-4xl text-center font-display text-[28px] font-700 uppercase leading-[1.08] text-cream b600:text-4xl b760:text-[42px] b900:text-5xl" data-id="element-124" data-mp="2wjz43frjfnay">
          Montá y hacé rentable tu pollería en{' '}
          <span className="text-mustard" data-id="element-125" data-mp="2msunycq4lwej">30 días</span> — con el mismo cajón que
          ya comprás
        </h1>

        <p className="mt-5 text-center" data-id="element-126" data-mp="2rrpe5zqfan8o">
          <span className="inline-block rounded-full border border-mustard/60 bg-mustard/10 px-4 py-1.5 text-xs font-700 text-mustard b640:text-sm" data-id="element-127" data-mp="2rqnvpa72uygx">
            {HERO.founderBadge}
          </span>
        </p>

        <div className="mt-8 grid items-center gap-10 b900:grid-cols-2 b900:gap-12" data-id="element-128" data-mp="2ff8w2yubigy2">
          {/* Copy column */}
          <div className="text-center b900:text-left" data-id="element-129" data-mp="2begk3xu29xy3">
            <p className="font-display text-sm font-700 uppercase tracking-[0.18em] text-mustard b640:text-base" data-id="element-130" data-mp="2bbu4dax0oc4s">
              {HERO.brand}
            </p>

            <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cream/85 b640:text-base b900:mx-0" data-id="element-131" data-mp="2kdk5j8gpapfr">
              {HERO.sub}
            </p>

            {/* Stats */}
            <ul className="mt-6 grid grid-cols-2 gap-3 b600:grid-cols-4" data-id="element-132" data-mp="2u4y1j69g1745">
              {HERO.stats.map(stat => <li key={stat.l} className="rounded-lg border border-cream/15 bg-bordo/60 px-3 py-2 text-center" data-id="element-133" data-mp="3834r7z48o0sq">
                  <span className="block font-display text-2xl font-700 leading-none text-mustard" data-id="element-134" data-mp="1dpwozmdxomx2">
                    {stat.n}
                  </span>
                  <span className="mt-1 block text-[11px] font-600 uppercase tracking-wide text-cream/75" data-id="element-135" data-mp="18smw1wrc5t4h">
                    {stat.l}
                  </span>
                </li>)}
            </ul>

            <div className="mt-6 flex flex-col items-center justify-center gap-2 b600:flex-row b600:gap-3 b900:justify-start" data-id="element-136" data-mp="3duii3qid55un">
              <StarRating className="text-mustard" size={18} data-id="element-137" data-mp="3msuhagxapbyp" />
              <span className="text-xs font-600 text-cream/85 b640:text-sm" data-id="element-138" data-mp="3mufc87niuwx3">
                {HERO.rating}
              </span>
            </div>

            <p className="mt-3 text-xs font-600 text-cream/70 b640:text-sm" data-id="element-139" data-mp="lcmpt95n1y1">
              {HERO.verified}
            </p>

            {/* Price */}
            <div className="mt-7" data-id="element-140" data-mp="5de6s1ckdwym">
              <span className="block text-xs font-700 uppercase tracking-[0.16em] text-mustard b640:text-sm" data-id="element-141" data-mp="abfrsrtjw6cq">
                {HERO.priceLabel}
              </span>
              <div className="mt-1 flex flex-wrap items-baseline justify-center gap-3 b900:justify-start" data-id="element-142" data-mp="ef3w91mvyltr">
                <span className="font-display text-xl font-500 text-cream/50 line-through b640:text-2xl" data-id="element-143" data-mp="jaaz678bzmhm">
                  {PRICE.full}
                </span>
                <span className="font-display text-5xl font-700 leading-none text-mustard b640:text-6xl" data-id="element-144" data-mp="1yua8vq7g141m">
                  {PRICE.today}
                </span>
              </div>
            </div>

            <div className="mx-auto mt-6 max-w-md b900:mx-0" data-id="element-145" data-mp="1pvoqpw5vvr1d">
              <CtaButton data-id="element-146" data-mp="2mko0xgq132w7">{HERO.cta}</CtaButton>
              <p className="mt-2 text-center text-xs text-cream/70" data-id="element-147" data-mp="2mjmfqjfat00r">
                {HERO.ctaSub}
              </p>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] font-600 text-cream/70 b640:text-xs b900:justify-start" data-id="element-148" data-mp="2ilont8u57zto">
              {HERO.trust.map(item => <li key={item} data-id="element-149" data-mp="28rerjg22yhdo">{item}</li>)}
            </ul>
          </div>

          {/* Product stack */}
          <div className="order-first b900:order-none" data-id="element-150" data-mp="31ige4283rf78">
            <img src={IMAGES.stack} alt={HERO.imgAlt} width={1200} height={900} loading="eager" fetchPriority="high" decoding="async" className="h-auto w-full rounded-2xl" data-id="element-151" data-mp="31glpactpn2xv" />
          </div>
        </div>
      </div>
    </section>;
}